import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'
import { ChargebeePlan } from '../types/chargebee'

export const getChargebeePlans = (): Promise<ChargebeePlan[]> => {
    return api.get('v2/chargebee/plans')
}

export const getChargebeePlansQueryOptions = () => {
    return queryOptions({
        queryKey: ['chargebee-plans'],
        queryFn: () => getChargebeePlans(),
    })
}

type UseChargebeePlansOptions = {
    queryConfig?: QueryConfig<typeof getChargebeePlans>
}

export const useChargebeePlans = ({ queryConfig }: UseChargebeePlansOptions = {}) => {
    return useQuery({
        ...getChargebeePlansQueryOptions(),
        ...queryConfig,
    })
}


